import { useCountryListStore } from '@/store/dictionary/country-list.store';
import { useCurrencyListStore } from '@/store/dictionary/currency-list.store';
import { usePaymentOperationListStore } from '@/store/dictionary/payment-operation-list.store';
import { storeToRefs } from 'pinia';
import { computed, defineComponent } from 'vue';
import {
  cancelledByFilterOptions,
  transactionStatusFilterOptions,
  moderationStatusFilterOptions,
  processingTypeFilterOptions,
  firstDepositFilterOptions,
} from '@/models/transaction/transaction-list-filter.model';
import { usePaymentSystemListStore } from '@/store/dictionary/payment-system-list.store';
import { usePaymentListStore } from '@/store/dictionary/payment-list.store';
import { usePaymentAccountListStore } from '@/store/dictionary/payment-account-list.store';
import { useBillingProviderListStore } from '@/store/dictionary/billing-provider-list.store';
import { useTransactionOperatingSystemListStore } from '@/store/dictionary/transaction-operating-system-list-store';
import { useTransactionListFilterStore } from '@/store/transaction/transaction-list-filter.store';
import { useAdminsStore } from '@/store/dictionary/admins.store';
import { PaymentListItem } from '@/models/dictionary/payment-list.model';
import { BillingProdiverListItem } from '@/models/dictionary/billing-provider-list.model';
import { PaymentSystemListItem } from '@/models/dictionary/payment-system-list.model';

export default defineComponent({
  name: 'TransactionsFilter',
  setup() {
    const transactionListFilterStore = useTransactionListFilterStore();
    const { changeFilter } = transactionListFilterStore;
    const { filterFormData } = storeToRefs(transactionListFilterStore);

    const { isPaymentOperationListLoading, paymentOperationList } = storeToRefs(usePaymentOperationListStore());
    const { isCountryListLoading, countryList } = storeToRefs(useCountryListStore());
    const { isCurrencyListLoading, currencyList } = storeToRefs(useCurrencyListStore());
    const { isPaymentListLoading, uniquePaymentList } = storeToRefs(usePaymentListStore());
    const { isPaymentSystemListLoading, uniquePaymentSystemList } = storeToRefs(usePaymentSystemListStore());
    const { isPaymentAccountListLoading, paymentAccountList } = storeToRefs(usePaymentAccountListStore());
    const { isBillingProviderListLoading, billingProviderList } = storeToRefs(useBillingProviderListStore());
    const {
      isTransactionOperatingSystemListLoading,
      transactionOperatingSystemList,
    } = storeToRefs(useTransactionOperatingSystemListStore());

    const adminsStore = useAdminsStore();
    const { adminEmailList, isAdminEmailListLoading } = storeToRefs(adminsStore);
    const { getAdminEmailList, clearAdminEmailList } = adminsStore;

    const getAdminEmails = (emailQuery: string) => {
      getAdminEmailList({
        filterList: {
          adminEmail: emailQuery,
        },
      });
    };

    const availablePaymentList = computed<PaymentListItem[]>(() =>
      uniquePaymentList.value.filter(
        (pspItem: PaymentListItem) =>
          !filterFormData.value.psp?.includes(pspItem.psp),
      ),
    );

    const availableBillingProviderList = computed<BillingProdiverListItem[]>(() =>
      billingProviderList.value.filter(
        (billingProviderItem: BillingProdiverListItem) =>
          !filterFormData.value.bpId?.includes(billingProviderItem.bpId),
      ),
    );

    const availablePaymentSystemList = computed<PaymentSystemListItem[]>(() =>
      uniquePaymentSystemList.value.filter(
        (paymentSystemItem: PaymentSystemListItem) =>
          !filterFormData.value.paymentSystem?.includes(paymentSystemItem.paymentSystem),
      ),
    );

    return {
      filterFormData,
      isPaymentOperationListLoading,
      paymentOperationList,
      isCountryListLoading,
      countryList,
      isCurrencyListLoading,
      currencyList,
      cancelledByFilterOptions,
      transactionStatusFilterOptions,
      moderationStatusFilterOptions,
      processingTypeFilterOptions,
      isPaymentSystemListLoading,
      availablePaymentSystemList,
      isPaymentListLoading,
      availablePaymentList,
      isPaymentAccountListLoading,
      paymentAccountList,
      isBillingProviderListLoading,
      availableBillingProviderList,
      firstDepositFilterOptions,
      isTransactionOperatingSystemListLoading,
      transactionOperatingSystemList,
      getAdminEmails,
      clearAdminEmailList,
      isAdminEmailListLoading,
      adminEmailList,
      changeFilter,
    };
  },
});
